export const SUBMIT_FEEDBACK_URL = gon.global?.jh
  ? 'https://gitlab.cn/'
  : 'https://about.gitlab.com/submit-feedback/';
export const LICENSING_FAQ_URL = gon.global?.jh
  ? 'https://gitlab.cn/pricing/'
  : 'https://about.gitlab.com/pricing/licensing-faq/';
export const DOCUMENTATION_URL = gon.global?.jh
  ? 'https://docs.gitlab.cn/docs/jh/subscriptions/'
  : 'https://docs.gitlab.com/subscriptions/';
